<template>
  <div class="edit-adduser--container">
    <form @submit.prevent="updateUser">
      <div class="input-block">
        <label for="edit_email"
          >Электронная почта <span class="req">*</span></label
        >
        <input
          @focus="user.email.error = ''"
          @blur="vEmail"
          type="text"
          v-model="user.email.model"
          id="edit_email"
        />
        <div class="form-error">{{ user.email.error }}</div>
      </div>
      <div class="input-block">
        <label for="edit_username">Имя <span class="req">*</span></label>
        <input
          @focus="user.username.error = ''"
          @blur="vUsername"
          type="text"
          v-model="user.username.model"
          id="edit_username"
        />
        <div class="form-error">{{ user.username.error }}</div>
      </div>
      <div class="input-block">
        <label for="edit_password">Пароль</label>
        <input type="text" v-model="user.password.model" id="edit_password" />
        <div class="hint">
          Если не собираетесь изменять пароль, то оставьте это поле пустым
        </div>
      </div>
      <div class="input-block">
        <label><b>Права и разрешения пользователя</b> <span class="req">*</span></label>
        <permissions-list
            :default="simpleSelect.default"
            :reset="resetSimpleSelect"
            @changeValue="changeCatSelect"
            class="mrg-t-15"
        ></permissions-list>

      </div>
      <div class="input-block">
        <label
        ><b>Компании доступные пользователю</b> <span class="req">*</span></label>
        <simple-select-checkbox
            :dataComponent="companyData"
            :reset="resetSimpleSelect"
            :default="simpleSelect.companyDefault"
            @changeValue="changeCompanySelect"
        ></simple-select-checkbox>
      </div>
      <div class="mrg-t-10 text-hint text-bold">
        После нажатия на кнопку "Соранить", доп.аккаунт будет выброшен из учетной записи.
        Ему нужно будет войти в учетную запись заново.
      </div>
      <div class="input-block mrg-t-10">
        <button type="submit" class="btn btn-sm btn-success">Сохранить</button>
      </div>
    </form>
  </div>
</template>

<script>

import Validator from "../../libraries/Validator";
import SimpleSelectCheckbox from "@/components/SimpleSelectCheckbox";
import adduserRepository from "../../../repositories/adduser";
import PermissionsList from "./PermissionsList.vue";

const validator = new Validator();

export default {
  name: "EditAdduser",
  components: {PermissionsList, SimpleSelectCheckbox},
  data() {
    return {
      user: {
        email: { model: "", error: "" },
        username: { model: "", error: "" },
        password: { model: "" }
      },
      resetSimpleSelect: 0,
      simpleSelect: {
        permList: [],
        resetSimpleSelect: false,
        selectedPerm: [],
        selectedCompanies: [],
        default: [],
        companyDefault: []
      }
    };
  },
  props: {
    dataUser: Object,
    permList: Array,
    companyData: Array,
    show: Boolean
  },
  watch: {
    dataUser: function(val) {
      this.user.email.model = val.email;
      this.user.username.model = val.username;
      this.simpleSelect.default = val.permissions;
      let companyIds = [];
      for (let keyComp in val.companies){
        companyIds[companyIds.length] = val.companies[keyComp].company_id;
      }
      this.simpleSelect.companyDefault = companyIds;
    },
  },
  computed: {
    validateData() {
      let errorCount = 0;
      this.vEmail().result === "error" ? errorCount++ : "";
      this.vUsername().result === "error" ? errorCount++ : "";

      return errorCount;
    }
  },
  methods: {
    vEmail() {
      let validate = validator.validate([
        {
          fieldName: "E-mail",
          value: this.user.email.model,
          type: "required",
          length: 255
        },
        { fieldName: "E-mail", value: this.user.email.model, type: "email" }
      ]);
      validate.result === "error"
        ? (this.user.email.error = validate.message)
        : (this.user.email.error = "");
      return validate;
    },
    vUsername() {
      let validate = validator.validate([
        {
          fieldName: "Имя пользователя",
          value: this.user.username.model,
          type: "required",
          length: 255
        }
      ]);
      validate.result === "error"
        ? (this.user.username.error = validate.message)
        : (this.user.username.error = "");
      return validate;
    },
    changeCatSelect(val) {
      this.simpleSelect.selectedPerm = val;
    },
    changeCompanySelect(val){
      this.simpleSelect.selectedCompanies = val;
    },
    updateUser() {
      if (this.validateData) {
        return false;
      }
      this.$store.dispatch("startPreloader");

      const data = {
        id: this.dataUser.id,
        email: this.user.email.model.trim(),
        username: this.user.username.model.trim(),
        password: this.user.password.model.trim(),
        permissions: JSON.stringify(this.simpleSelect.selectedPerm),
        companies: JSON.stringify(this.simpleSelect.selectedCompanies)
      };

      adduserRepository.updateUser(data).then(resp => {
        if (resp.data.result === "ok") {
          this.$emit("updateUser");
          this.$store.dispatch("addNotification", {
            text: "Данные пользователя изменены",
            time: 3,
            color: "success"
          });
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
